export enum AttachmentType {
  IMAGE = 'IMAGE',
  PDF = 'PDF',
}

export type Attachment = {
  data: string | undefined | null;
  mimeType: string | null;
  name: string | undefined | null;
  path: string;
  size: number | null;
  type: AttachmentType;
};
